export const UPLOAD_IMAGE_MAX_SIZE = 10485760; //10mb
export const UPLOAD_SOUND_MAX_SIZE = 10485760; //10mb
export const UPLOAD_FONT_MAX_SIZE = 10485760; //10mb
export const BYTE_TO_MEGABYTE = 1048576;

export const DEFAULT_LANG = 'ko';